import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import DraftsCard from './components/Drafts/DraftsCard';
import PostsCard from './components/Posts/PostsCard';
import {withTranslation} from "react-i18next";

const PostsPage = ({t}) => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">{t('posts.title')}</h3>
      </Col>
    </Row>
    <Row>
      <DraftsCard />
      <PostsCard/>
    </Row>
  </Container>
);

export default withTranslation('dashboard')(PostsPage);
